import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2} from '@angular/core';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {FileSelectFieldConfig} from '../file-select-field.config';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IdedMydocmaFile} from '@mydocma/common/src/lib/file';
import { FileRetryClickEvent, FileState } from '@mydocma/component-library/src/lib/drag-drop-file-upload';

@UntilDestroy()
@Component({
    selector: 'mydocma-form-files-select',
    templateUrl: './file-select-field.component.html',
    styleUrls: ['./file-select-field.component.scss']
})
export class FileSelectFieldComponent extends BaseFieldComponent<FileSelectFieldConfig> implements OnInit {

    public readonly staticCssClass = 'mydocma-file-select-field';
    public isFileExist = false;
    public files = [];
    public readers = [];
    public types = [];

    public multiSelect;

    public emptyMap= new Map<string,FileState>();

    constructor(
        private readonly zone: NgZone,
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);
    }

    async ngOnInit() {
        super.ngOnInit();
        this.setInitFileSelectConfig(false);
        this.updateFieldValue(this.fieldWrapper.config.value, false);
        this.control.valueChanges.pipe(untilDestroyed(this))
            .subscribe((value) => {
                this.updateFieldValue(value);
            })
    }

    public async onFilesAdded(fileList: File[]): Promise<void> {

        for (const value of this.files) {
            if (value.name === fileList[0].name && await this.readFileAsText(value) === await this.readFileAsText(fileList[0])) {
                return;
            }
        }
        this.files = [...this.files];
        this.files.push(...fileList);

        this.control.setValue(this.files);

        if (this.fieldWrapper.config?.onFilesAdded) {
            this.fieldWrapper.config?.onFilesAdded(fileList);
        }
        this.control.markAsTouched();
        this.eventDispatcher.notifyFilesAdded(fileList);

    }



    public async onRetryFileAction(event:FileRetryClickEvent ) {
        if (this.fieldWrapper.config?.onRetryFileAction) {
           await this.fieldWrapper.config?.onRetryFileAction(event.file)
        }
    }
    public async onFileDeleted(event: { file: IdedMydocmaFile, index: number }): Promise<void> {
        const index = this.files.indexOf(event.file);
        let file;
        if (index > -1) {
            file = this.files.splice(index, 1);
            this.files = [...this.files];
            setTimeout(() => this.control.setValue(this.files));
        }

        if (this.fieldWrapper.config?.onFileDeleted) {
            this.fieldWrapper.config?.onFileDeleted(file);
        }
        this.control.markAsTouched();

        this.eventDispatcher.notifyFileDelete(file);
    }

    public async onFieldWrapperUpdated() {
        super.onFieldWrapperUpdated();

        this.setInitFileSelectConfig();

    }

    private setInitFileSelectConfig(emitEvent = true): void {

        this.multiSelect = this.fieldWrapper.config?.selectMultiple;

        this.types = this.fieldWrapper.config?.acceptedTypes || [];

        if (this.fieldWrapper?.config?.value?.length > 1 && !this.multiSelect) {

            this.files = [this.fieldWrapper?.config?.value[0]];

        } else {
            this.files = [...(this.fieldWrapper?.config?.value || [])];
        }

        this.control.setValue(this.files, {emitEvent});
    }

    private updateFieldValue(value: IdedMydocmaFile[], emitEvent = true): void {
        if (!value?.length) {
            this.files = [];
            return
        }
        if (this.fieldWrapper.config.selectMultiple) {
            this.files = [...value];
        } else {
            this.files = [value[0]];
        }

    }

    private readFileAsText(file: File): Promise<string | ArrayBuffer> {
        return new Promise((resolve) => {
            const fr = new FileReader();

            fr.onload = () => {
                resolve(fr.result);
            };
            fr.readAsText(file);
        });
    }
}
